import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { EmailTemplatesDataGrid } from "src/components/views/erp/common/emailTemplate/EmailTemplatesDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/common/emailTemplates")({
	staticData: { title: i18n.t("email_templates"), legacyViewKey: "emailTemplatesPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <EmailTemplatesDataGrid />;
}
